import { createHandler } from '@mews/std';
import {
    arrowCounterClockwise1,
    arrowCounterClockwise2,
    arrowCounterClockwise3,
    arrowCounterClockwise4,
    arrowCounterClockwise5,
    arrowCounterClockwise6,
    arrowCounterClockwise7,
    arrowCounterClockwise8,
    arrowCounterClockwise9,
    arrowCounterClockwise9plus,
} from '@optimus-web/assets';
import { IconName } from '@optimus-web/core';

export const advancedReturningClassificationIconNameHandler = createHandler<
    number,
    { component: React.FC; iconName: IconName }
>(
    {
        1: { component: arrowCounterClockwise1, iconName: IconName.ArrowCounterClockwise1 },
        2: { component: arrowCounterClockwise2, iconName: IconName.ArrowCounterClockwise2 },
        3: { component: arrowCounterClockwise3, iconName: IconName.ArrowCounterClockwise3 },
        4: { component: arrowCounterClockwise4, iconName: IconName.ArrowCounterClockwise4 },
        5: { component: arrowCounterClockwise5, iconName: IconName.ArrowCounterClockwise5 },
        6: { component: arrowCounterClockwise6, iconName: IconName.ArrowCounterClockwise6 },
        7: { component: arrowCounterClockwise7, iconName: IconName.ArrowCounterClockwise7 },
        8: { component: arrowCounterClockwise8, iconName: IconName.ArrowCounterClockwise8 },
        9: { component: arrowCounterClockwise9, iconName: IconName.ArrowCounterClockwise9 },
    },
    { component: arrowCounterClockwise9plus, iconName: IconName.ArrowCounterClockwise9plus }
);
